import { Site } from '@pubstack/common/src/site'
import { FunctionComponent } from 'react'
import { Link } from '~/components/Link'
import { Skeleton } from '~/components/Skeleton'
import { ConnectToPubstack } from '~/feature-components/connect/ConnectToPubstack'

type PureSiteConnectToPubstackProps = {
  site: Site
  /**
   * Whether the media is still being fetched.
   *
   * The page context stands an empty media in until it arrives, and that stand-in carries neither product
   * flag — so a plan built from it reads as an un-activated Analytics media and would show One's own page a
   * Node activation prompt and a boot tag with no id in it.
   */
  isLoading: boolean
  onUseAnalyticsScriptsClick: () => void
}

/**
 * One's media page.
 *
 * The instructions are the shared ones now. This page used to write the `/v1/adm/` URL out by hand, which
 * is half of how the javascript form of the tag came to point at the analytics runtime everywhere else;
 * and its "Site preparation" card said what to take off the page first on this one screen only, where a
 * publisher connecting a One media from the media flyout needed it just as much. That warning travels with
 * the instructions now — see the `site-preparation` note in `connectPlan`.
 */
export const PureSiteConnectToPubstack: FunctionComponent<PureSiteConnectToPubstackProps> = ({ site, isLoading, onUseAnalyticsScriptsClick }) => (
  <div className="rounded bg-white p-5">
    {isLoading ? (
      <div className="flex flex-col gap-4">
        <Skeleton width={'60%'} />
        <Skeleton bigger width={'100%'} />
        <Skeleton bigger width={'100%'} />
      </div>
    ) : (
      <ConnectToPubstack site={site} trackingPrefix={'adm-sites-stacks-connect'} />
    )}
    <div className="flex flex-wrap whitespace-nowrap pt-6 font-roboto text-sm leading-[1.375rem]">
      Want to use only the analytics features and keep your monetisation settings on a page?&nbsp;
      <Link onClick={onUseAnalyticsScriptsClick} label={'Use this script'} trackingLabel={'adm-sites-stacks-connect-settings-site-navigate'} />
    </div>
  </div>
)
